import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';

@Component({
    selector: 'app-person-payment-details',
    templateUrl: './person-payment-details.component.html',
    imports: [
        CardComponent,
        TextInputComponent,
    ],
})
export class PersonPaymentDetailsComponent {
    form = input.required<FormGroup | null>();
    canEdit = input(false);
}
